import { SHTypography } from "@components/design-systems";
import { RenderAnalysisSummaryItemProps } from "@models/platform-analysis/entities/steps/summary";
import { FeeCalculatorPortfolioLevel } from "@models/platform-analysis/enums/fee/portfolioLevel";
import { Box } from "@mui/material";
import { RootState } from "@redux/store";
import { memo } from "react";
import { SummaryPortfolioCompositionContainer } from "../portfolio-composition/container";

export const SummaryAppendixPortfolioComposition = memo(
  ({ name, userType, portfolioLevel }: RenderAnalysisSummaryItemProps) => {
    if (portfolioLevel !== FeeCalculatorPortfolioLevel.Family) return <></>;

    return (
      <SummaryPortfolioCompositionContainer
        title={
          <SHTypography variant="subtitle2">
            {name?.[userType]}{" "}
            <Box component="span" fontWeight={400}>
              of platforms that made it to fee review stage but were not
              selected
            </Box>
          </SHTypography>
        }
        showControls={false}
        getPortfolioCompositionDataFunc={(state: RootState) =>
          state.platformAnalysis?.platformAnalysis?.summary
            ?.disqualifiedPortfolioCompositionByPlatform
        }
      />
    );
  },
);
